/*============ nonGMAuthController controller
 ================================*/
angular
    .module('vppApp')
    .controller('nonGMDealershipAuthController', nonGMDealershipAuthController);

nonGMDealershipAuthController.$inject = ['$scope', '$rootScope', '$state', 'apiFactory', 'dobFilter', 'ScrollToService', 'DTMTrackerService'];

function nonGMDealershipAuthController($scope, $rootScope, $state, apiFactory, dobFilter, ScrollToService, DTMTrackerService) {
    $scope.responsePending = false;
    $scope.authSuccess = false;
    $scope.serverError = '';

    $scope.formData = {
        firstName: '',
        lastName: '',
        email: '',
        confirmEmail: '',
        employingDealerAddress:'',
        city: '',
        state: '',
        zip: '',
        purchaserFirstName: '',
        purchaserLastName: '',
        purchaserRelationship: '',
        purchaserDob: '',
        purchaserZip: '',
        employingNonGMDealershipName: '',
        employeeStartDate: '',
        purchaseDealer: '',
        purchaseBac:'',
        offerType: ''
    };

    DTMTrackerService.updatePageLoadData('pageType', 'eligibility form');

    $scope.submit = function (formData) {
        // disable submit button
        $scope.responsePending = true;

        // date formatting
        $scope.formData.purchaserDob = dobFilter($scope.formData.purchaserDob);
        $scope.formData.employeeStartDate = dobFilter($scope.formData.employeeStartDate);
        // submit form
        apiFactory.nonGMDealershipEmployeeAuthorization(formData)
            .then(function successEligibility(response) {

                // hide form, show success content
                $scope.authSuccess = true;

                DTMTrackerService.updatePageLoadData('pageType', 'Non-GM dealership employee authorization form-thanks');
                DTMTrackerService.directCall('form-success');

                // scroll to top of page
                window.localStorage.removeItem("idOrName_");
                window.localStorage['idOrName_'] = 'ng-app';
                ScrollToService.idOrName(undefined);

            }, function errorCallback(response) {
                // re-enable submit button
                $scope.responsePending = false;

                // set var to display errors
                $scope.serverError = response.data.errors;
            });
    };
};
